export const TruckBulky = ({width = 12, height = 12}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <path
        fill="#8057F6"
        d="M12.16 2.387h-1.04v.295a.91.91 0 1 1-1.819 0v-.295H5.014v.295a.91.91 0 1 1-1.819 0v-.295H2.117A1.117 1.117 0 0 0 .998 3.503v1.514h12.28V3.503a1.116 1.116 0 0 0-1.118-1.116ZM.998 5.78v5.732a1.117 1.117 0 0 0 1.12 1.117H12.16a1.116 1.116 0 0 0 1.119-1.117V5.78H.999Z"
      />
      <path
        fill="#8057F6"
        d="M10.665 1.183v1.5a.455.455 0 1 1-.91 0v-1.5a.455.455 0 1 1 .91 0ZM4.56 1.183v1.5a.455.455 0 0 1-.91 0v-1.5a.455.455 0 1 1 .91 0Z"
      />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M5.655 6.865v4.184H6.8v.619h.446v-.62c.294-.003.547-.049.76-.136.222-.096.393-.232.512-.41a1.1 1.1 0 0 0 .187-.646.969.969 0 0 0-.127-.521.805.805 0 0 0-.333-.32 1.41 1.41 0 0 0-.48-.156v-.033c.258-.039.458-.14.6-.306a.899.899 0 0 0 .22-.62c0-.36-.131-.623-.393-.788-.217-.137-.533-.217-.946-.24V6.33H6.8v.535H5.655Zm1.145.632h-.48v1.069h.48v-1.07Zm0 1.688h-.48v1.225h.48V9.185Zm.446 1.223v-1.22c.247.013.423.068.527.166a.549.549 0 0 1 .186.424c0 .182-.06.335-.18.456-.104.106-.281.164-.533.174Zm0-1.847V7.506c.174.016.31.055.407.115.133.082.2.212.2.39 0 .17-.056.305-.167.405-.087.081-.234.13-.44.145Z"
        clip-rule="evenodd"
      />
    </svg>
  );
};
